import { Chapter, Reveal, MaskLines, ArrowLink } from "./Reveal";
import NetworkGraphic from "./NetworkGraphic";

export default function Quidory() {
  return (
    <section
      id="quidory"
      data-testid="quidory-section"
      className="relative mx-auto max-w-[1400px] px-6 py-28 lg:px-12 lg:py-40"
    >
      <div className="pointer-events-none absolute left-0 top-40 h-[400px] w-[400px] rounded-full bg-steel/15 blur-[150px]" />
      <Chapter index="01" label="Quidory · AI SaaS" className="mb-10" />

      <div className="grid grid-cols-1 items-center gap-14 lg:grid-cols-2 lg:gap-20">
        <div>
          <h2 className="font-display text-4xl font-extrabold leading-[1.05] tracking-tighter text-cloud sm:text-5xl">
            <MaskLines lines={["The AI automation", "platform for the region."]} />
          </h2>
          <Reveal delay={0.15}>
            <p className="mt-8 max-w-xl font-body text-base font-light leading-relaxed text-fog sm:text-lg">
              Quidory is our AI agent SaaS platform, purpose-built for businesses
              across the GCC and MENA region. With Arabic-first agent capabilities,
              it lets teams automate support, operations, and customer conversations
              natively — no compromise in language, dialect, or context.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-5 max-w-xl border-l-2 border-steel pl-5 font-body text-sm font-light leading-relaxed text-fog/90 sm:text-base" data-testid="quidory-reputation-note">
              We engineer automated reputation management systems, empowering
              hospitality and retail businesses to manage customer feedback and
              review response workflows seamlessly via Google Business Profile
              integrations.
            </p>
          </Reveal>
          <Reveal delay={0.25} className="mt-10">
            <ArrowLink href="https://quidory.com" testid="quidory-visit-btn" primary>
              Visit Quidory
            </ArrowLink>
          </Reveal>
        </div>

        <Reveal delay={0.2}>
          <NetworkGraphic
            variant="agent"
            label="Arabic-first agents"
            badge="Live"
            className="aspect-square w-full"
          />
        </Reveal>
      </div>
    </section>
  );
}
